import { __decorate, __metadata } from "tslib";
import { Pipe } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
let SafeStylePipe = class SafeStylePipe {
    constructor(domSanitizer) {
        this.domSanitizer = domSanitizer;
    }
    transform(style) {
        return this.domSanitizer.bypassSecurityTrustStyle(style);
    }
};
SafeStylePipe.ctorParameters = () => [
    { type: DomSanitizer }
];
SafeStylePipe = __decorate([
    Pipe({
        name: 'safeStyle',
    }),
    __metadata("design:paramtypes", [DomSanitizer])
], SafeStylePipe);
export { SafeStylePipe };
